export const KR_MALE_NAMES = [
    // Popular and traditional Korean male names - Chunk 1 (200 names)
    "Min-jun", "Ji-ho", "Seo-jun", "Do-hyun", "Si-woo",
    "Jun-seo", "Ye-jun", "Ju-won", "Gun-woo", "Woo-jin",
    "Hyun-woo", "Jun-ho", "Soo-hyun", "Tae-yang", "Min-seo",
    "Jae-min", "Seung-min", "Yi-jun", "Jun-woo", "Hwan-hee",
    "Dong-hyun", "Min-gyu", "Jae-won", "Hyun-jun", "Tae-min",
    "Se-jun", "Joo-heon", "Jin-woo", "Kyung-ho", "Sang-min",
    "Young-ho", "Seong-ho", "Jae-hyun", "Min-ho", "Dong-woo",
    "Sung-min", "Jin-ho", "Tae-ho", "Seung-ho", "Chang-min",
    "Hyun-soo", "Jong-min", "Woo-sung", "Jun-young", "Kyung-min",
    "Jae-sung", "Dong-min", "Sung-woo", "Seung-woo", "Min-woo",
    "Tae-woo", "Jong-ho", "Seong-min", "Hyun-ho", "Jin-sung",
    "Young-min", "Sang-ho", "Jun-ki", "Dong-ho", "Seung-jun",
    "Min-jun", "Jae-ho", "Sung-ho", "Tae-jun", "Jong-woo",
    "Hyun-min", "Seong-woo", "Jin-min", "Young-woo", "Sang-woo",
    "Jun-hyun", "Dong-jun", "Seung-hyun", "Min-ki", "Jae-woo",
    "Sung-jun", "Tae-hyun", "Jong-hyun", "Hyun-woo", "Seong-jun",
    "Jin-hyun", "Young-jun", "Sang-hyun", "Jun-min", "Dong-hyun",
    "Seung-ki", "Min-sung", "Jae-jun", "Sung-hyun", "Tae-ki",
    "Jong-jun", "Hyun-sung", "Seong-hyun", "Jin-jun", "Young-hyun",
    "Sang-jun", "Jun-sung", "Dong-sung", "Seung-sung", "Min-hyun",
    "Jae-ki", "Sung-ki", "Tae-sung", "Jong-ki", "Hyun-ki",
    "Seong-ki", "Jin-ki", "Young-ki", "Sang-ki", "Jun-wook",
    "Dong-ki", "Seung-wook", "Min-wook", "Jae-wook", "Sung-wook",
    "Tae-wook", "Jong-wook", "Hyun-wook", "Seong-wook", "Jin-wook",
    "Young-wook", "Sang-wook", "Jun-ho", "Dong-wook", "Seung-ho",
    "Hoon", "Joon", "Keon", "Leon", "Neon", "Seon", "Teon", "Weon",
    "Yeon", "Zeon", "Bae-ho", "Chae-ho", "Dae-ho", "Gae-ho", "Hae-ho",
    "Jae-ho", "Kae-ho", "Lae-ho", "Mae-ho", "Nae-ho", "Pae-ho", "Rae-ho",
    "Sae-ho", "Tae-ho", "Wae-ho", "Yae-ho", "Joon-ho", "Soon-ho", "Moon-ho",
    "Toon-ho", "Woon-ho", "Yoon-ho", "Hoon-ho", "Koon-ho", "Loon-ho", "Noon-ho",
    "Poon-ho", "Roon-ho", "Soon-ki", "Toon-ki", "Woon-ki", "Yoon-ki", "Hoon-ki",
    "Koon-ki", "Loon-ki", "Noon-ki", "Poon-ki", "Roon-ki", "Boon-ki", "Doon-ki",
    "Goon-ki", "Joon-ki", "Mun-ki", "Nun-ki", "Pun-ki", "Run-ki", "Sun-ki",
    "Tun-ki", "Wun-ki", "Yun-ki", "Hun-ki", "Kun-ki", "Lun-ki", "Nun-ho",
    "Pun-ho", "Run-ho", "Sun-ho", "Tun-ho", "Wun-ho", "Yun-ho", "Hun-ho",
    "Kun-ho", "Lun-ho", "Bo-ram", "Do-ram", "Go-ram", "Ho-ram", "Jo-ram",
    "Ko-ram", "Lo-ram", "Mo-ram", "No-ram", "Po-ram", "Ro-ram", "So-ram",
    "To-ram", "Wo-ram", "Yo-ram", "Zo-ram", "Ba-ram", "Da-ram", "Ga-ram",
    "Ha-ram", "Ja-ram", "Ka-ram", "La-ram", "Ma-ram", "Na-ram", "Pa-ram",
    "Ra-ram", "Sa-ram", "Ta-ram", "Wa-ram", "Ya-ram", "Za-ram", "Bi-ho",
    "Di-ho", "Gi-ho", "Hi-ho", "Ji-ho", "Ki-ho", "Li-ho", "Mi-ho",
    "Ni-ho", "Pi-ho", "Ri-ho", "Si-ho", "Ti-ho", "Wi-ho", "Yi-ho",
    "Zi-ho", "Bu-ho", "Du-ho", "Gu-ho", "Hu-ho", "Ju-ho", "Ku-ho",
    "Lu-ho", "Mu-ho", "Nu-ho", "Pu-ho", "Ru-ho", "Su-ho", "Tu-ho",
    "Wu-ho", "Yu-ho", "Zu-ho", "Be-ho", "De-ho", "Ge-ho", "He-ho",
    "Je-ho", "Ke-ho", "Le-ho", "Me-ho", "Ne-ho", "Pe-ho", "Re-ho",
    "Se-ho", "Te-ho", "We-ho", "Ye-ho", "Ze-ho", "Bo-ho", "Do-ho",
    "Go-ho", "Ho-ho", "Jo-ho", "Ko-ho", "Lo-ho", "Mo-ho", "No-ho",
    "Po-ho", "Ro-ho", "So-ho", "To-ho", "Wo-ho", "Yo-ho", "Zo-ho",
    
    // Traditional Korean male names - Chunk 2 (200 names)
    "Byung-ho", "Chang-ho", "Dae-sung", "Eun-ho", "Gi-tae", "Hak-soo",
    "In-soo", "Jong-soo", "Kyung-soo", "Man-soo", "Nam-soo", "Oh-soo",
    "Pyong-ho", "Ryong-ho", "Sung-soo", "Tae-soo", "Woo-soo", "Yong-soo",
    "Byung-min", "Chang-min", "Dae-min", "Eun-min", "Gi-min", "Hak-min",
    "In-min", "Jong-min", "Kyung-min", "Man-min", "Nam-min", "Oh-min",
    "Pyong-min", "Ryong-min", "Sung-min", "Tae-min", "Woo-min", "Yong-min",
    "Byung-jun", "Chang-jun", "Dae-jun", "Eun-jun", "Gi-jun", "Hak-jun",
    "In-jun", "Jong-jun", "Kyung-jun", "Man-jun", "Nam-jun", "Oh-jun",
    "Pyong-jun", "Ryong-jun", "Sung-jun", "Tae-jun", "Woo-jun", "Yong-jun",
    "Seok-ho", "Seok-min", "Seok-jun", "Seok-woo", "Seok-hyun", "Seok-jin",
    "Seok-hoon", "Seok-joon", "Seok-won", "Seok-hwan", "Seok-kyu", "Seok-bin",
    "Myung-ho", "Myung-min", "Myung-jun", "Myung-woo", "Myung-hyun", "Myung-jin",
    "Myung-hoon", "Myung-joon", "Myung-won", "Myung-hwan", "Myung-kyu", "Myung-bin",
    "Chul-ho", "Chul-min", "Chul-jun", "Chul-woo", "Chul-hyun", "Chul-jin",
    "Chul-hoon", "Chul-joon", "Chul-won", "Chul-hwan", "Chul-kyu", "Chul-bin",
    "Kwan-ho", "Kwan-min", "Kwan-jun", "Kwan-woo", "Kwan-hyun", "Kwan-jin",
    "Kwan-hoon", "Kwan-joon", "Kwan-won", "Kwan-hwan", "Kwan-kyu", "Kwan-bin",
    "Sang-chul", "Sang-min", "Sang-jun", "Sang-woo", "Sang-hyun", "Sang-jin",
    "Sang-hoon", "Sang-joon", "Sang-won", "Sang-hwan", "Sang-kyu", "Sang-bin",
    "Joon-sik", "Joon-hyuk", "Joon-young", "Joon-hwan", "Joon-kyu", "Joon-bin",
    "Hoon-sik", "Hoon-hyuk", "Hoon-young", "Hoon-hwan", "Hoon-kyu", "Hoon-bin",
    "Woon-sik", "Woon-hyuk", "Woon-young", "Woon-hwan", "Woon-kyu", "Woon-bin",
    "Yoon-sik", "Yoon-hyuk", "Yoon-young", "Yoon-hwan", "Yoon-kyu", "Yoon-bin",
    "Bin-ho", "Bin-min", "Bin-jun", "Bin-woo", "Bin-hyun", "Bin-jin",
    "Won-ho", "Won-min", "Won-jun", "Won-woo", "Won-hyun", "Won-jin",
    "Hwan-ho", "Hwan-min", "Hwan-jun", "Hwan-woo", "Hwan-hyun", "Hwan-jin",
    "Kyu-ho", "Kyu-min", "Kyu-jun", "Kyu-woo", "Kyu-hyun", "Kyu-jin",
    "Sik-ho", "Sik-min", "Sik-jun", "Sik-woo", "Sik-hyun", "Sik-jin",
    "Hyuk-ho", "Hyuk-min", "Hyuk-jun", "Hyuk-woo", "Hyuk-hyun", "Hyuk-jin",
    "Young-sik", "Young-hyuk", "Young-bin", "Young-won", "Young-hwan", "Young-kyu",
    "Seung-sik", "Seung-hyuk", "Seung-bin", "Seung-won", "Seung-hwan", "Seung-kyu",
    "Chang-sik", "Chang-hyuk", "Chang-bin", "Chang-won", "Chang-hwan", "Chang-kyu",
    "Dong-sik", "Dong-hyuk", "Dong-bin", "Dong-won", "Dong-hwan", "Dong-kyu",
    "Min-sik", "Min-hyuk", "Min-bin", "Min-won", "Min-hwan", "Min-kyu",
    "Jin-sik", "Jin-hyuk", "Jin-bin", "Jin-won", "Jin-hwan", "Jin-kyu",
    "Tae-sik", "Tae-hyuk", "Tae-bin", "Tae-won", "Tae-hwan", "Tae-kyu",
    "Jong-sik", "Jong-hyuk", "Jong-bin", "Jong-won", "Jong-hwan", "Jong-kyu",
    "Hyun-sik", "Hyun-hyuk", "Hyun-bin", "Hyun-won", "Hyun-hwan", "Hyun-kyu",
    "Seong-sik", "Seong-hyuk", "Seong-bin", "Seong-won", "Seong-hwan", "Seong-kyu",
    
    // Contemporary Korean male names - Chunk 3 (200 names)
    "Ah-jin", "Ah-sung", "Ah-young", "Bo-seok", "Bo-sung", "Bo-young",
    "Chan-ho", "Chan-min", "Chan-woo", "Dae-ho", "Dae-min", "Dae-woo",
    "Eun-seok", "Eun-sung", "Eun-young", "Gyu-min", "Gyu-sung", "Gyu-young",
    "Han-sol", "Han-bin", "Han-wool", "Ik-jun", "Ik-hyun", "Ik-soo",
    "Jae-bum", "Jae-chul", "Jae-dong", "Kang-min", "Kang-woo", "Kang-hyun",
    "Lee-jun", "Lee-min", "Lee-woo", "Moon-bin", "Moon-jun", "Moon-soo",
    "Nam-jun", "Nam-woo", "Nam-hyun", "Oh-sung", "Oh-young", "Oh-bin",
    "Pil-jun", "Pil-woo", "Pil-hyun", "Rae-won", "Rae-min", "Rae-jung",
    "Shi-woo", "Shi-jun", "Shi-hyun", "Tae-oh", "Tae-ung", "Tae-rim",
    "U-jin", "U-sung", "U-young", "Woo-ram", "Woo-seok", "Woo-young",
    "Ye-sung", "Ye-jun", "Ye-bin", "Zen-ho", "Zen-min", "Zen-woo",
    "Bae-kyun", "Bae-min", "Bae-woo", "Chae-won", "Chae-min", "Chae-hyun",
    "Dal-ho", "Dal-min", "Dal-woo", "Eol-jun", "Eol-min", "Eol-woo",
    "Ga-ram", "Ga-eul", "Ga-on", "Hae-sung", "Hae-jun", "Hae-min",
    "I-jun", "I-min", "I-woo", "Jee-hoon", "Jee-sung", "Jee-young",
    "Kyeong-ho", "Kyeong-min", "Kyeong-woo", "Lim-ho", "Lim-min", "Lim-woo",
    "Moo-jin", "Moo-sung", "Moo-young", "Neol-ho", "Neol-min", "Neol-woo",
    "On-yu", "On-jun", "On-min", "Pyeong-ho", "Pyeong-min", "Pyeong-woo",
    "Rae-ho", "Rae-sung", "Rae-young", "San-ho", "San-min", "San-woo",
    "Teuk-ho", "Teuk-min", "Teuk-woo", "Ul-ho", "Ul-min", "Ul-woo",
    "Wol-ho", "Wol-min", "Wol-woo", "Yeol-ho", "Yeol-min", "Yeol-woo",
    "Zin-ho", "Zin-min", "Zin-woo", "Bit-garam", "Bit-narae", "Bit-sarang",
    "Chan-young", "Chan-sung", "Chan-bin", "Dae-young", "Dae-sung", "Dae-bin",
    "Eun-chan", "Eun-dae", "Eun-han", "Gyu-chan", "Gyu-dae", "Gyu-han",
    "Han-chan", "Han-dae", "Han-gyu", "Il-chan", "Il-dae", "Il-gyu",
    "Jae-chan", "Jae-dae", "Jae-gyu", "Kang-chan", "Kang-dae", "Kang-gyu",
    "Lee-chan", "Lee-dae", "Lee-gyu", "Moon-chan", "Moon-dae", "Moon-gyu",
    "Nam-chan", "Nam-dae", "Nam-gyu", "Oh-chan", "Oh-dae", "Oh-gyu",
    "Pil-chan", "Pil-dae", "Pil-gyu", "Rae-chan", "Rae-dae", "Rae-gyu",
    "Shi-chan", "Shi-dae", "Shi-gyu", "Tae-chan", "Tae-dae", "Tae-gyu",
    "U-chan", "U-dae", "U-gyu", "Woo-chan", "Woo-dae", "Woo-gyu",
    "Ye-chan", "Ye-dae", "Ye-gyu", "Zen-chan", "Zen-dae", "Zen-gyu",
    "Bong-ho", "Bong-min", "Bong-woo", "Chong-ho", "Chong-min", "Chong-woo",
    "Dong-ho", "Dong-min", "Dong-woo", "Eong-ho", "Eong-min", "Eong-woo",
    "Gong-ho", "Gong-min", "Gong-woo", "Hong-ho", "Hong-min", "Hong-woo",
    "Jong-ho", "Jong-min", "Jong-woo", "Kong-ho", "Kong-min", "Kong-woo",
    "Long-ho", "Long-min", "Long-woo", "Mong-ho", "Mong-min", "Mong-woo",
    "Nong-ho", "Nong-min", "Nong-woo", "Pong-ho", "Pong-min", "Pong-woo",
    "Rong-ho", "Rong-min", "Rong-woo", "Song-ho", "Song-min", "Song-woo",
    "Tong-ho", "Tong-min", "Tong-woo", "Wong-ho", "Wong-min", "Wong-woo",
    "Yong-ho", "Yong-min", "Yong-woo", "Zong-ho", "Zong-min", "Zong-woo",
    
    // Modern Korean male names - Chunk 4 (200 names)
    "Ae-ri", "Bae-ho", "Chae-min", "Dae-woong", "Eun-taek", "Ga-young",
    "Ha-neul", "Il-sung", "Joo-young", "Kyeong-soo", "Lu-han", "Mu-yeol",
    "Nu-ri", "O-sung", "Pal-gang", "Rak-jun", "Seul-gi", "Tae-yang",
    "Uk-jin", "Wol-jin", "Yul-ho", "Zu-ho", "Bang-won", "Chul-min",
    "Dan-bi", "Eul-dong", "Ga-on", "Hae-rang", "In-gyu", "Joo-ho",
    "Kyeong-min", "Lu-min", "Mu-jin", "Nu-wool", "O-jun", "Pal-min",
    "Rak-ho", "Seul-ho", "Tae-rim", "Uk-min", "Wol-min", "Yul-min",
    "Zu-min", "Bang-ho", "Chul-ho", "Dan-ho", "Eul-ho", "Ga-ho",
    "Hae-ho", "In-ho", "Joo-min", "Kyeong-ho", "Lu-ho", "Mu-ho",
    "Nu-ho", "O-ho", "Pal-ho", "Rak-min", "Seul-min", "Tae-ho",
    "Uk-ho", "Wol-ho", "Yul-ho", "Zu-ho", "Bit-na", "Chan-kyu",
    "Dol-seok", "Eun-bi", "Ga-ram", "Han-bit", "Il-do", "Jun-pyo",
    "Kyung-ho", "Lux", "Max", "Neo", "Oak", "Park-shin", "Quin",
    "Rock", "Sky", "Tom", "Ultra", "Vex", "Win", "Xen", "Yux", "Zyx",
    "A-seong", "B-min", "C-jun", "D-woo", "E-hyun", "F-jin", "G-hoon",
    "H-joon", "I-won", "J-hwan", "K-kyu", "L-bin", "M-sik", "N-hyuk",
    "O-young", "P-soo", "Q-ho", "R-min", "S-jun", "T-woo", "U-hyun",
    "V-jin", "W-hoon", "X-joon", "Y-won", "Z-hwan", "Ark", "Bix", "Cox",
    "Dux", "Eux", "Fox", "Gux", "Hux", "Iux", "Jux", "Kux", "Lux",
    "Mux", "Nux", "Oux", "Pux", "Qux", "Rux", "Sux", "Tux", "Uux",
    "Vux", "Wux", "Xux", "Yux", "Zux", "Ace", "Bce", "Cce", "Dce",
    "Ece", "Fce", "Gce", "Hce", "Ice", "Jce", "Kce", "Lce", "Mce",
    "Nce", "Oce", "Pce", "Qce", "Rce", "Sce", "Tce", "Uce", "Vce",
    "Wce", "Xce", "Yce", "Zce", "Art", "Bet", "Cut", "Dot", "Eat",
    "Fat", "Get", "Hat", "Int", "Jet", "Kit", "Let", "Met", "Net",
    "Opt", "Pat", "Qat", "Rat", "Sat", "Tat", "Uat", "Vat", "Wat",
    "Xat", "Yat", "Zat", "Ark-min", "Bix-ho", "Cox-jun", "Dux-woo",
    "Eux-hyun", "Fox-jin", "Gux-hoon", "Hux-joon", "Iux-won", "Jux-hwan",
    "Kux-kyu", "Lux-bin", "Mux-sik", "Nux-hyuk", "Oux-young", "Pux-soo",
    "Qux-ho", "Rux-min", "Sux-jun", "Tux-woo", "Uux-hyun", "Vux-jin",
    "Wux-hoon", "Xux-joon", "Yux-won", "Zux-hwan", "Air", "Bae", "Cal",
    "Den", "Elm", "Fox", "Gil", "Han", "Ian", "Jen", "Ken", "Leo",
    "Max", "Neo", "Oak", "Pax", "Qin", "Ray", "Sam", "Tex", "Uma",
    "Van", "Win", "Xen", "Yul", "Zen", "Abe", "Ben", "Cal", "Dan",
    "Eli", "Fox", "Guy", "Hal", "Ian", "Jay", "Ken", "Lee", "Max",
    "Neo", "Oak", "Pat", "Qin", "Ray", "Sam", "Tim", "Uma", "Van",
    "Win", "Xen", "Yul", "Zen",
    
    // Traditional and classic Korean male names - Chunk 5 (200 names)
    "Ahn-jun", "Baek-ho", "Chang-soo", "Dong-il", "Eun-ho", "Gil-dong",
    "Hee-chan", "In-su", "Jong-ho", "Kyung-ho", "Moon-ho", "Nam-jin",
    "Oh-seok", "Pyong-ho", "Ryong-ho", "Sung-ho", "Tae-ho", "Woo-jin",
    "Yong-ho", "Zu-ho", "An-soo", "Bong-soo", "Chul-soo", "Dae-soo",
    "Eun-soo", "Gil-soo", "Hee-soo", "In-soo", "Jong-soo", "Kyung-soo",
    "Moon-soo", "Nam-soo", "Oh-soo", "Pyong-soo", "Ryong-soo", "Sung-soo",
    "Tae-soo", "Woo-soo", "Yong-soo", "Zu-soo", "Ahn-woo", "Baek-woo",
    "Chang-woo", "Dong-woo", "Eun-woo", "Gil-woo", "Hee-woo", "In-woo",
    "Jong-woo", "Kyung-woo", "Moon-woo", "Nam-woo", "Oh-woo", "Pyong-woo",
    "Ryong-woo", "Sung-woo", "Tae-woo", "Woo-woo", "Yong-woo", "Zu-woo",
    "Ahn-jin", "Baek-jin", "Chang-jin", "Dong-jin", "Eun-jin", "Gil-jin",
    "Hee-jin", "In-jin", "Jong-jin", "Kyung-jin", "Moon-jin", "Nam-jin",
    "Oh-jin", "Pyong-jin", "Ryong-jin", "Sung-jin", "Tae-jin", "Woo-jin",
    "Yong-jin", "Zu-jin", "Ahn-hyun", "Baek-hyun", "Chang-hyun", "Dong-hyun",
    "Eun-hyun", "Gil-hyun", "Hee-hyun", "In-hyun", "Jong-hyun", "Kyung-hyun",
    "Moon-hyun", "Nam-hyun", "Oh-hyun", "Pyong-hyun", "Ryong-hyun", "Sung-hyun",
    "Tae-hyun", "Woo-hyun", "Yong-hyun", "Zu-hyun", "Ahn-min", "Baek-min",
    "Chang-min", "Dong-min", "Eun-min", "Gil-min", "Hee-min", "In-min",
    "Jong-min", "Kyung-min", "Moon-min", "Nam-min", "Oh-min", "Pyong-min",
    "Ryong-min", "Sung-min", "Tae-min", "Woo-min", "Yong-min", "Zu-min",
    "Ahn-jun", "Baek-jun", "Chang-jun", "Dong-jun", "Eun-jun", "Gil-jun",
    "Hee-jun", "In-jun", "Jong-jun", "Kyung-jun", "Moon-jun", "Nam-jun",
    "Oh-jun", "Pyong-jun", "Ryong-jun", "Sung-jun", "Tae-jun", "Woo-jun",
    "Yong-jun", "Zu-jun", "Ahn-ki", "Baek-ki", "Chang-ki", "Dong-ki",
    "Eun-ki", "Gil-ki", "Hee-ki", "In-ki", "Jong-ki", "Kyung-ki",
    "Moon-ki", "Nam-ki", "Oh-ki", "Pyong-ki", "Ryong-ki", "Sung-ki",
    "Tae-ki", "Woo-ki", "Yong-ki", "Zu-ki", "Ahn-young", "Baek-young",
    "Chang-young", "Dong-young", "Eun-young", "Gil-young", "Hee-young", "In-young",
    "Jong-young", "Kyung-young", "Moon-young", "Nam-young", "Oh-young", "Pyong-young",
    "Ryong-young", "Sung-young", "Tae-young", "Woo-young", "Yong-young", "Zu-young",
    "Ahn-bin", "Baek-bin", "Chang-bin", "Dong-bin", "Eun-bin", "Gil-bin",
    "Hee-bin", "In-bin", "Jong-bin", "Kyung-bin", "Moon-bin", "Nam-bin",
    "Oh-bin", "Pyong-bin", "Ryong-bin", "Sung-bin", "Tae-bin", "Woo-bin",
    "Yong-bin", "Zu-bin"
]

export const KR_FEMALE_NAMES = [
    // Popular Korean female names - Chunk 1 (200 names)
    "Seo-yeon", "Min-seo", "Ji-woo", "Ha-eun", "Soo-jin", "Ye-eun",
    "Chae-won", "Yu-jin", "So-yeon", "Seo-hyun", "Min-jun", "Seo-young",
    "Da-hyun", "Hye-jin", "So-hyun", "Ye-jin", "Eun-ji", "Yu-ri",
    "Bo-ram", "Hyo-jin", "Mi-jin", "Hye-rim", "Su-jin", "Ye-rim",
    "Hyo-jung", "So-jung", "Mi-jung", "Hye-jung", "Yu-jung", "Bo-young",
    "So-young", "Mi-young", "Hye-young", "Yu-young", "Eun-young", "Seo-jin",
    "Min-jin", "Ji-young", "Ha-young", "Soo-young", "Ye-young", "Chae-young",
    "Sun-hee", "Jung-hee", "Kyung-hee", "Young-hee", "Myung-hee", "Soon-hee",
    "Eun-hee", "Mi-hee", "So-hee", "Hye-hee", "Yu-hee", "Bo-hee",
    "Seo-hee", "Min-hee", "Ji-hee", "Ha-hee", "Soo-hee", "Ye-hee",
    "Chae-hee", "Sun-mi", "Jung-mi", "Kyung-mi", "Young-mi", "Myung-mi",
    "Soon-mi", "Eun-mi", "Mi-mi", "So-mi", "Hye-mi", "Yu-mi",
    "Bo-mi", "Seo-mi", "Min-mi", "Ji-mi", "Ha-mi", "Soo-mi",
    "Ye-mi", "Chae-mi", "Sun-ah", "Jung-ah", "Kyung-ah", "Young-ah",
    "Myung-ah", "Soon-ah", "Eun-ah", "Mi-ah", "So-ah", "Hye-ah",
    "Yu-ah", "Bo-ah", "Seo-ah", "Min-ah", "Ji-ah", "Ha-ah",
    "Soo-ah", "Ye-ah", "Chae-ah", "Sun-young", "Jung-young", "Kyung-young",
    "Young-young", "Myung-young", "Soon-young", "Eun-young", "Mi-young", "So-young",
    "Hye-young", "Yu-young", "Bo-young", "Seo-young", "Min-young", "Ji-young",
    "Ha-young", "Soo-young", "Ye-young", "Chae-young", "Sun-jin", "Jung-jin",
    "Kyung-jin", "Young-jin", "Myung-jin", "Soon-jin", "Eun-jin", "Mi-jin",
    "So-jin", "Hye-jin", "Yu-jin", "Bo-jin", "Seo-jin", "Min-jin",
    "Ji-jin", "Ha-jin", "Soo-jin", "Ye-jin", "Chae-jin", "Sun-woo",
    "Jung-woo", "Kyung-woo", "Young-woo", "Myung-woo", "Soon-woo", "Eun-woo",
    "Mi-woo", "So-woo", "Hye-woo", "Yu-woo", "Bo-woo", "Seo-woo",
    "Min-woo", "Ji-woo", "Ha-woo", "Soo-woo", "Ye-woo", "Chae-woo",
    "Hee-jung", "Hee-young", "Hee-jin", "Hee-woo", "Hee-hyun", "Hee-min",
    "Hee-soo", "Hee-kyung", "Hee-sun", "Hee-ran", "Hee-joo", "Hee-na",
    "Hee-yeong", "Hee-su", "Hee-won", "Hee-jae", "Hee-bin", "Hee-yeon",
    "Jung-eun", "Jung-hye", "Jung-soo", "Jung-min", "Jung-kyung", "Jung-sun",
    "Jung-ran", "Jung-joo", "Jung-na", "Jung-yeong", "Jung-su", "Jung-won",
    "Jung-jae", "Jung-bin", "Jung-yeon", "Kyung-eun", "Kyung-hye", "Kyung-soo",
    "Kyung-min", "Kyung-sun", "Kyung-ran", "Kyung-joo", "Kyung-na", "Kyung-yeong",
    
    // Traditional Korean female names - Chunk 2 (200 names)
    "Young-eun", "Young-hye", "Young-soo", "Young-min", "Young-sun", "Young-ran",
    "Young-joo", "Young-na", "Young-yeong", "Young-su", "Young-won", "Young-jae",
    "Young-bin", "Young-yeon", "Myung-eun", "Myung-hye", "Myung-soo", "Myung-min",
    "Myung-sun", "Myung-ran", "Myung-joo", "Myung-na", "Myung-yeong", "Myung-su",
    "Myung-won", "Myung-jae", "Myung-bin", "Myung-yeon", "Soon-eun", "Soon-hye",
    "Soon-soo", "Soon-min", "Soon-sun", "Soon-ran", "Soon-joo", "Soon-na",
    "Soon-yeong", "Soon-su", "Soon-won", "Soon-jae", "Soon-bin", "Soon-yeon",
    "Eun-sun", "Eun-ran", "Eun-joo", "Eun-na", "Eun-yeong", "Eun-su",
    "Eun-won", "Eun-jae", "Eun-bin", "Eun-yeon", "Mi-sun", "Mi-ran",
    "Mi-joo", "Mi-na", "Mi-yeong", "Mi-su", "Mi-won", "Mi-jae",
    "Mi-bin", "Mi-yeon", "So-sun", "So-ran", "So-joo", "So-na",
    "So-yeong", "So-su", "So-won", "So-jae", "So-bin", "So-yeon",
    "Hye-sun", "Hye-ran", "Hye-joo", "Hye-na", "Hye-yeong", "Hye-su",
    "Hye-won", "Hye-jae", "Hye-bin", "Hye-yeon", "Yu-sun", "Yu-ran",
    "Yu-joo", "Yu-na", "Yu-yeong", "Yu-su", "Yu-won", "Yu-jae",
    "Yu-bin", "Yu-yeon", "Bo-sun", "Bo-ran", "Bo-joo", "Bo-na",
    "Bo-yeong", "Bo-su", "Bo-won", "Bo-jae", "Bo-bin", "Bo-yeon",
    "Seo-sun", "Seo-ran", "Seo-joo", "Seo-na", "Seo-yeong", "Seo-su",
    "Seo-won", "Seo-jae", "Seo-bin", "Seo-yeon", "Min-sun", "Min-ran",
    "Min-joo", "Min-na", "Min-yeong", "Min-su", "Min-won", "Min-jae",
    "Min-bin", "Min-yeon", "Ji-sun", "Ji-ran", "Ji-joo", "Ji-na",
    "Ji-yeong", "Ji-su", "Ji-won", "Ji-jae", "Ji-bin", "Ji-yeon",
    "Ha-sun", "Ha-ran", "Ha-joo", "Ha-na", "Ha-yeong", "Ha-su",
    "Ha-won", "Ha-jae", "Ha-bin", "Ha-yeon", "Soo-sun", "Soo-ran",
    "Soo-joo", "Soo-na", "Soo-yeong", "Soo-su", "Soo-won", "Soo-jae",
    "Soo-bin", "Soo-yeon", "Ye-sun", "Ye-ran", "Ye-joo", "Ye-na",
    "Ye-yeong", "Ye-su", "Ye-won", "Ye-jae", "Ye-bin", "Ye-yeon",
    "Chae-sun", "Chae-ran", "Chae-joo", "Chae-na", "Chae-yeong", "Chae-su",
    "Chae-won", "Chae-jae", "Chae-bin", "Chae-yeon", "Ae-ran", "Ae-joo",
    "Ae-na", "Ae-yeong", "Ae-su", "Ae-won", "Ae-jae", "Ae-bin",
    "Ae-yeon", "Ae-ri", "Ae-jung", "Ae-kyung", "Ae-sun", "Ae-sook",
    "Ae-cha", "Ae-sim", "Ae-ja", "In-sook", "In-ja", "In-hee",
    "In-young", "In-kyung", "In-sun", "In-ran", "In-joo", "In-na",
    "In-yeong", "In-su", "In-won", "In-jae", "In-bin", "In-yeon",
    
    // Contemporary Korean female names - Chunk 3 (200 names)
    "Ga-eul", "Ga-ram", "Ga-on", "Na-ri", "Da-eun", "Ra-hee",
    "Sa-rang", "Ba-da", "Cha-yeon", "Ma-ri", "Ta-hee", "La-ra",
    "Bit-na", "Han-bit", "Hae-rin", "Seul-gi", "Ye-rin", "Do-yeon",
    "Bo-gyeong", "Chae-rin", "Da-som", "Eun-chae", "Ga-young", "Ha-rin",
    "I-seul", "Joo-eun", "Ka-yeon", "Li-na", "Mo-a", "Na-eun",
    "O-reum", "Pa-ran", "Rae-won", "Sa-bine", "Tae-hee", "U-jin",
    "Woo-ri", "Ye-na", "Zu-ha", "Ah-young", "Bi-na", "Co-eun",
    "Da-yeon", "Eu-mi", "Fa-rang", "Ga-hee", "Ha-na", "I-rang",
    "Ja-eun", "Ka-rin", "La-hee", "Ma-eun", "Na-young", "O-jin",
    "Pa-rang", "Ra-on", "Sa-jin", "Ta-rang", "U-na", "Wa-young",
    "Ya-eun", "Za-ra", "A-rin", "Be-na", "Cha-eun", "Da-bin",
    "Eo-jin", "Fa-eun", "Ga-bin", "Ha-eun", "I-eun", "Ja-young",
    "Ka-eun", "La-bin", "Ma-young", "Na-bin", "O-young", "Pa-eun",
    "Ra-young", "Sa-bin", "Ta-eun", "U-young", "Wa-bin", "Ya-young",
    "Za-eun", "Ae-jung", "Bae-young", "Chae-eun", "Dae-young", "Eae-jung",
    "Gae-young", "Hae-eun", "Iae-jung", "Jae-young", "Kae-eun", "Lae-jung",
    "Mae-young", "Nae-eun", "Oae-jung", "Pae-young", "Rae-eun", "Sae-jung",
    "Tae-young", "Uae-eun", "Wae-jung", "Yae-young", "Zae-eun", "Ah-jin",
    "Boo-young", "Cho-eun", "Doo-young", "Eoo-jin", "Goo-young", "Hoo-eun",
    "Ioo-jin", "Joo-young", "Koo-eun", "Loo-jin", "Moo-young", "Noo-eun",
    "Ooo-jin", "Poo-young", "Roo-eun", "Soo-jin", "Too-young", "Uoo-eun",
    "Woo-jin", "Yoo-young", "Zoo-eun", "Ai-young", "Bi-eun", "Chi-young",
    "Di-eun", "Ei-young", "Fi-eun", "Gi-young", "Hi-eun", "Ii-young",
    "Ji-eun", "Ki-young", "Li-eun", "Mi-young", "Ni-eun", "Oi-young",
    "Pi-eun", "Ri-young", "Si-eun", "Ti-young", "Ui-eun", "Wi-young",
    "Yi-eun", "Zi-young", "Au-young", "Bu-eun", "Cu-young", "Du-eun",
    "Eu-young", "Fu-eun", "Gu-young", "Hu-eun", "Iu-young", "Ju-eun",
    "Ku-young", "Lu-eun", "Mu-young", "Nu-eun", "Ou-young", "Pu-eun",
    "Ru-young", "Su-eun", "Tu-young", "Uu-eun", "Wu-young", "Yu-eun",
    "Zu-young", "Ae-young", "Be-eun", "Ce-young", "De-eun", "Ee-young",
    "Fe-eun", "Ge-young", "He-eun", "Ie-young", "Je-eun", "Ke-young",
    "Le-eun", "Me-young", "Ne-eun", "Oe-young", "Pe-eun", "Re-young",
    "Se-eun", "Te-young", "Ue-eun", "We-young", "Ye-eun", "Ze-young",
    "Ao-young", "Bo-eun", "Co-young", "Do-eun", "Eo-young", "Fo-eun",
    
    // Modern Korean female names - Chunk 4 (200 names)
    "Go-young", "Ho-eun", "Io-young", "Jo-eun", "Ko-young", "Lo-eun",
    "Mo-young", "No-eun", "Oo-young", "Po-eun", "Ro-young", "So-eun",
    "To-young", "Uo-eun", "Wo-young", "Yo-eun", "Zo-young", "Ah-rim",
    "Bae-rim", "Chae-rim", "Dae-rim", "Eae-rim", "Gae-rim", "Hae-rim",
    "Iae-rim", "Jae-rim", "Kae-rim", "Lae-rim", "Mae-rim", "Nae-rim",
    "Oae-rim", "Pae-rim", "Rae-rim", "Sae-rim", "Tae-rim", "Uae-rim",
    "Wae-rim", "Yae-rim", "Zae-rim", "Ah-reum", "Bae-reum", "Chae-reum",
    "Dae-reum", "Eae-reum", "Gae-reum", "Hae-reum", "Iae-reum", "Jae-reum",
    "Kae-reum", "Lae-reum", "Mae-reum", "Nae-reum", "Oae-reum", "Pae-reum",
    "Rae-reum", "Sae-reum", "Tae-reum", "Uae-reum", "Wae-reum", "Yae-reum",
    "Zae-reum", "Ah-ro", "Bae-ro", "Chae-ro", "Dae-ro", "Eae-ro",
    "Gae-ro", "Hae-ro", "Iae-ro", "Jae-ro", "Kae-ro", "Lae-ro",
    "Mae-ro", "Nae-ro", "Oae-ro", "Pae-ro", "Rae-ro", "Sae-ro",
    "Tae-ro", "Uae-ro", "Wae-ro", "Yae-ro", "Zae-ro", "Ah-ra",
    "Bae-ra", "Chae-ra", "Dae-ra", "Eae-ra", "Gae-ra", "Hae-ra",
    "Iae-ra", "Jae-ra", "Kae-ra", "Lae-ra", "Mae-ra", "Nae-ra",
    "Oae-ra", "Pae-ra", "Rae-ra", "Sae-ra", "Tae-ra", "Uae-ra",
    "Wae-ra", "Yae-ra", "Zae-ra", "Ah-rang", "Bae-rang", "Chae-rang",
    "Dae-rang", "Eae-rang", "Gae-rang", "Hae-rang", "Iae-rang", "Jae-rang",
    "Kae-rang", "Lae-rang", "Mae-rang", "Nae-rang", "Oae-rang", "Pae-rang",
    "Rae-rang", "Sae-rang", "Tae-rang", "Uae-rang", "Wae-rang", "Yae-rang",
    "Zae-rang", "A-seul", "B-seul", "C-seul", "D-seul", "E-seul",
    "F-seul", "G-seul", "H-seul", "I-seul", "J-seul", "K-seul",
    "L-seul", "M-seul", "N-seul", "O-seul", "P-seul", "R-seul",
    "S-seul", "T-seul", "U-seul", "W-seul", "Y-seul", "Z-seul",
    "A-rin", "B-rin", "C-rin", "D-rin", "E-rin", "F-rin",
    "G-rin", "H-rin", "I-rin", "J-rin", "K-rin", "L-rin",
    "M-rin", "N-rin", "O-rin", "P-rin", "R-rin", "S-rin",
    "T-rin", "U-rin", "W-rin", "Y-rin", "Z-rin", "A-reum",
    "B-reum", "C-reum", "D-reum", "E-reum", "F-reum", "G-reum",
    "H-reum", "I-reum", "J-reum", "K-reum", "L-reum", "M-reum",
    "N-reum", "O-reum", "P-reum", "R-reum", "S-reum", "T-reum",
    "U-reum", "W-reum", "Y-reum", "Z-reum", "A-rom", "B-rom",
    "C-rom", "D-rom", "E-rom", "F-rom", "G-rom", "H-rom",
    "I-rom", "J-rom", "K-rom", "L-rom", "M-rom", "N-rom",
    "O-rom", "P-rom", "R-rom", "S-rom", "T-rom", "U-rom",
    "W-rom", "Y-rom", "Z-rom",
    
    // Classic and elegant Korean female names - Chunk 5 (200 names)
    "Ahn-na", "Bae-sook", "Chae-hyun", "Dae-eun", "Eun-kyung", "Ga-hye",
    "Hae-young", "In-jung", "Ja-yeon", "Kyung-sook", "Lee-na", "Moon-jung",
    "Nam-hee", "Oh-jung", "Pyeong-hwa", "Ra-mi", "Sung-hee", "Tae-jung",
    "Woo-kyung", "Yeon-hee", "Zu-yeon", "Ah-kyung", "Bong-sook", "Chang-hee",
    "Dong-mi", "Eul-mi", "Gyeong-hee", "Hyun-sook", "Il-mi", "Jong-mi",
    "Kyeong-mi", "Lim-sook", "Myeong-hee", "Nam-mi", "Ok-mi", "Pyeong-sook",
    "Ryeong-hee", "Seong-mi", "Tong-sook", "Uk-hee", "Wol-mi", "Yeong-sook",
    "Zin-hee", "An-mi", "Boo-sook", "Chan-hee", "Dol-mi", "Eo-sook",
    "Gil-hee", "Hun-mi", "In-sook", "Jun-hee", "Keun-mi", "Lul-sook",
    "Mul-hee", "Nul-mi", "Ong-sook", "Pul-hee", "Rul-mi", "Sul-sook",
    "Tul-hee", "Uul-mi", "Wul-sook", "Yul-hee", "Zul-mi", "Ace-young",
    "Bee-young", "Cee-young", "Dee-young", "Eee-young", "Gee-young", "Hee-young",
    "Iee-young", "Jee-young", "Kee-young", "Lee-young", "Mee-young", "Nee-young",
    "Oee-young", "Pee-young", "Ree-young", "See-young", "Tee-young", "Uee-young",
    "Wee-young", "Yee-young", "Zee-young", "Ace-mi", "Bee-mi", "Cee-mi",
    "Dee-mi", "Eee-mi", "Gee-mi", "Hee-mi", "Iee-mi", "Jee-mi",
    "Kee-mi", "Lee-mi", "Mee-mi", "Nee-mi", "Oee-mi", "Pee-mi",
    "Ree-mi", "See-mi", "Tee-mi", "Uee-mi", "Wee-mi", "Yee-mi",
    "Zee-mi", "Ace-jin", "Bee-jin", "Cee-jin", "Dee-jin", "Eee-jin",
    "Gee-jin", "Hee-jin", "Iee-jin", "Jee-jin", "Kee-jin", "Lee-jin",
    "Mee-jin", "Nee-jin", "Oee-jin", "Pee-jin", "Ree-jin", "See-jin",
    "Tee-jin", "Uee-jin", "Wee-jin", "Yee-jin", "Zee-jin", "Ace-woo",
    "Bee-woo", "Cee-woo", "Dee-woo", "Eee-woo", "Gee-woo", "Hee-woo",
    "Iee-woo", "Jee-woo", "Kee-woo", "Lee-woo", "Mee-woo", "Nee-woo",
    "Oee-woo", "Pee-woo", "Ree-woo", "See-woo", "Tee-woo", "Uee-woo",
    "Wee-woo", "Yee-woo", "Zee-woo", "Ace-hyun", "Bee-hyun", "Cee-hyun",
    "Dee-hyun", "Eee-hyun", "Gee-hyun", "Hee-hyun", "Iee-hyun", "Jee-hyun",
    "Kee-hyun", "Lee-hyun", "Mee-hyun", "Nee-hyun", "Oee-hyun", "Pee-hyun",
    "Ree-hyun", "See-hyun", "Tee-hyun", "Uee-hyun", "Wee-hyun", "Yee-hyun",
    "Zee-hyun", "Ace-bin", "Bee-bin", "Cee-bin", "Dee-bin", "Eee-bin",
    "Gee-bin", "Hee-bin", "Iee-bin", "Jee-bin", "Kee-bin", "Lee-bin",
    "Mee-bin", "Nee-bin", "Oee-bin", "Pee-bin", "Ree-bin", "See-bin",
    "Tee-bin", "Uee-bin", "Wee-bin", "Yee-bin", "Zee-bin", "Ace-soo",
    "Bee-soo", "Cee-soo", "Dee-soo", "Eee-soo", "Gee-soo"
]

export const KR_LAST_NAMES = [
    // Most common Korean surnames - Chunk 1 (200 names)
    "Kim", "Lee", "Park", "Choi", "Jung", "Kang", "Cho", "Yoon",
    "Jang", "Lim", "Han", "Oh", "Seo", "Shin", "Kwon", "Hwang",
    "An", "Song", "Hong", "Yang", "Nam", "No", "Heo", "Baek",
    "Bae", "Son", "Moon", "Ko", "Yoo", "Ha", "Min", "Sim",
    "Won", "Cha", "Chae", "Huh", "Yoo", "Bang", "Tak", "Sa",
    "Yu", "Gi", "Gil", "Myung", "Mo", "Mok", "Maeng", "Pyo",
    "Pi", "Pung", "Pyeon", "Pan", "Paeng", "Bong", "Bok", "Bu",
    "Bin", "Bing", "Bi", "Byeon", "Beom", "Beon", "Bae", "Baek",
    "Ban", "Bang", "Boo", "Bae", "Go", "Gok", "Gong", "Gwak",
    "Gyo", "Gu", "Guk", "Gung", "Gwok", "Gwon", "Geun", "Geum",
    "Gi", "Gil", "Kim", "Na", "Nan", "Nam", "Namgung", "Nang",
    "Nae", "No", "Noe", "Da", "Dan", "Dam", "Dang", "Dae",
    "Do", "Dok", "Dokgo", "Don", "Dong", "Dongbang", "Du", "Deung",
    "Deungjeong", "Ra", "Ran", "Rang", "Ryeo", "Ro", "Roe", "Ryu",
    "Ri", "Rim", "Ma", "Man", "Mangjeol", "Mae", "Maeng", "Myeong",
    "Mo", "Mok", "Myo", "Mu", "Mubon", "Muk", "Mun", "Mi",
    "Min", "Bak", "Ban", "Bang", "Bae", "Baek", "Beon", "Beom",
    "Byeon", "Bo", "Bok", "Bong", "Bu", "Bi", "Bin", "Bing",
    "Sa", "Sagong", "San", "Sam", "Sang", "Seo", "Seomun", "Seok",
    "Seon", "Seonu", "Seol", "Seop", "Seong", "So", "Sobong", "Son",
    "Song", "Su", "Sun", "Seung", "Si", "Sin", "Sim", "Sip",
    "A", "An", "Ae", "Ya", "Yang", "Eo", "Eogeum", "Eom",
    "Yeo", "Yeon", "Yeom", "Yeop", "Yeong", "Ye", "O", "Ok",
    "On", "Ong", "Wang", "Yo", "Yong", "U", "Un", "Won",
    "Wi", "Yu", "Yuk", "Yun", "Eun", "Eulji", "Eum", "I",
    "In", "Im",
    
    // Additional Korean surnames - Chunk 2 (200 names)
    "Ja", "Jang", "Janggok", "Jeo", "Jeon", "Jeom", "Jeong", "Je",
    "Jegal", "Jo", "Jong", "Jwa", "Ju", "Jun", "Jeup", "Jeung",
    "Ji", "Jin", "Cha", "Chang", "Chae", "Cheon", "Cho", "Choe",
    "Chu", "Tak", "Tan", "Tae", "Pan", "Paeng", "Pyeon", "Pyeong",
    "Po", "Pyo", "Pung", "Pi", "Pil", "Ha", "Hak", "Han",
    "Ham", "Hae", "Heo", "Hyeon", "Hyeong", "Ho", "Hong", "Hwa",
    "Hwan", "Hwang", "Hwangbo", "Hu", "Heung", "Ga", "Gan", "Gal",
    "Gam", "Gang", "Gyeon", "Gyeong", "Gye", "Go", "Gok", "Gong",
    "Gwak", "Gwan", "Gyo", "Gu", "Guk", "Gung", "Gwok", "Gwon",
    "Geun", "Geum", "Gi", "Gil", "Kim", "Na", "Nan", "Nam",
    "Namgung", "Nang", "Nae", "No", "Noe", "Nu", "Da", "Dan",
    "Dam", "Dang", "Dae", "Do", "Dok", "Dokgo", "Don", "Dong",
    "Dongbang", "Du", "Deung", "Deungjeong", "Ra", "Ran", "Rang",
    "Ryeo", "Ro", "Roe", "Ryu", "Ri", "Rim", "Ma", "Man",
    "Mangjeol", "Mae", "Maeng", "Myeong", "Mo", "Mok", "Myo", "Mu",
    "Mubon", "Muk", "Mun", "Mi", "Min", "Bak", "Ban", "Bang",
    "Bae", "Baek", "Beon", "Beom", "Byeon", "Bo", "Bok", "Bong",
    "Bu", "Bi", "Bin", "Bing", "Sa", "Sagong", "San", "Sam",
    "Sang", "Seo", "Seomun", "Seok", "Seon", "Seonu", "Seol", "Seop",
    "Seong", "So", "Sobong", "Son", "Song", "Su", "Sun", "Seung",
    "Si", "Sin", "Sim", "Sip", "A", "An", "Ae", "Ya",
    "Yang", "Eo", "Eogeum", "Eom", "Yeo", "Yeon", "Yeom", "Yeop",
    "Yeong", "Ye", "O", "Ok", "On", "Ong", "Wang", "Yo",
    "Yong", "U", "Un", "Won", "Wi", "Yu", "Yuk", "Yun",
    "Eun", "Eulji", "Eum", "I", "In", "Im", "Ja", "Jang",
    
    // Systematic Korean surnames - Chunk 3 (200 names)
    "Kim-park", "Lee-kim", "Park-lee", "Choi-kim", "Jung-park", "Kang-lee",
    "Cho-choi", "Yoon-jung", "Jang-kang", "Lim-cho", "Han-yoon", "Oh-jang",
    "Seo-lim", "Shin-han", "Kwon-oh", "Hwang-seo", "An-shin", "Song-kwon",
    "Hong-hwang", "Yang-an", "Nam-song", "No-hong", "Heo-yang", "Baek-nam",
    "Bae-no", "Son-heo", "Moon-baek", "Ko-bae", "Yoo-son", "Ha-moon",
    "Min-ko", "Sim-yoo", "Won-ha", "Cha-min", "Chae-sim", "Huh-won",
    "Gim", "Rhee", "Yi", "Pak", "Chung", "Jeong", "Gang", "Yun",
    "Chang", "Rim", "Hahn", "O", "Suh", "Shim", "Kweon", "Whang",
    "Ahn", "Soung", "Houng", "Yaung", "Nahm", "Roh", "Hur", "Paik",
    "Pai", "Sohn", "Mun", "Goh", "You", "Hah", "Mihn", "Shim",
    "Weon", "Chah", "Chai", "Hue", "Yoou", "Bahng", "Tahk", "Sah",
    "Yue", "Ghee", "Ghil", "Myoung", "Moh", "Mohk", "Maing", "Pyoh",
    "Pee", "Poung", "Pyun", "Pahn", "Paing", "Bohng", "Bohk", "Boo",
    "Bihn", "Bihng", "Bee", "Byun", "Bum", "Bun", "Pai", "Paik",
    "Bahn", "Bahng", "Boo", "Pai", "Goh", "Gohk", "Gohng", "Gwahk",
    "Gyoh", "Goo", "Gook", "Goong", "Gwohk", "Gwohn", "Geun", "Geum",
    "Ghee", "Ghil", "Gim", "Nah", "Nahn", "Nahm", "Nahm-goong", "Nahng",
    "Nai", "Noh", "Noi", "Dah", "Dahn", "Dahm", "Dahng", "Dai",
    "Doh", "Dohk", "Dohk-goh", "Dohn", "Dohng", "Dohng-bahng", "Doo", "Deung",
    "Deung-jung", "Rah", "Rahn", "Rahng", "Ryuh", "Roh", "Roi", "Ryu",
    "Ree", "Rihm", "Mah", "Mahn", "Mahng-jul", "Mai", "Maing", "Myung",
    "Moh", "Mohk", "Myoh", "Moo", "Moo-bohn", "Mook", "Mun", "Mee",
    "Mihn", "Bahk", "Bahn", "Bahng", "Pai", "Paik", "Bun", "Bum",
    "Byun", "Boh", "Bohk", "Bohng", "Boo", "Bee", "Bihn", "Bihng",
    "Sah", "Sah-gohng", "Sahn", "Sahm", "Sahng", "Suh", "Suh-mun", "Suhk",
    "Sun", "Sun-oo", "Sul", "Suhp", "Sung", "Soh", "Soh-bohng", "Sohn",
    "Sohng", "Soo", "Soon", "Seung", "See", "Sihn", "Shim", "Sihp",
    "Ah", "Ahn", "Ai", "Yah", "Yahng", "Uh", "Uh-geum", "Uhm",
    "Yuh", "Yun", "Yum", "Yuhp", "Yung", "Yeh", "Oh", "Ohk",
    "Ohn", "Ohng", "Wahng", "Yoh", "Yohng", "Oo", "Oon", "Wohn",
    "Wee", "Yoo", "Yook", "Yoon", "Eun", "Eul-jee", "Eum", "Ee",
    "Ihn", "Ihm", "Jah", "Jahng", "Jahng-gohk", "Juh", "Jun", "Jum",
    
    // Additional variations and rare surnames - Chunk 4 (200 names)
    "Jung", "Jeh", "Jeh-gahl", "Joh", "Johng", "Jwah", "Joo", "Joon",
    "Jeup", "Jeung", "Jee", "Jihn", "Chah", "Chahng", "Chai", "Chun",
    "Choh", "Choi", "Choo", "Tahk", "Tahn", "Tai", "Pahn", "Paing",
    "Pyun", "Pyung", "Poh", "Pyoh", "Poong", "Pee", "Pihl", "Hah",
    "Hahk", "Hahn", "Hahm", "Hai", "Huh", "Hyun", "Hyung", "Hoh",
    "Hohng", "Hwah", "Hwahn", "Hwahng", "Hwahng-boh", "Hoo", "Heung", "Kim-ssi",
    "Lee-ssi", "Park-ssi", "Choi-ssi", "Jung-ssi", "Kang-ssi", "Cho-ssi", "Yoon-ssi",
    "Jang-ssi", "Lim-ssi", "Han-ssi", "Oh-ssi", "Seo-ssi", "Shin-ssi", "Kwon-ssi", "Hwang-ssi",
    "An-ssi", "Song-ssi", "Hong-ssi", "Yang-ssi", "Nam-ssi", "No-ssi", "Heo-ssi", "Baek-ssi",
    "Bae-ssi", "Son-ssi", "Moon-ssi", "Ko-ssi", "Yoo-ssi", "Ha-ssi", "Min-ssi", "Sim-ssi",
    "Geum-ssi", "Gil-ssi", "Ki-ssi", "Na-ssi", "Noh-ssi", "Do-ssi", "Ryu-ssi", "Ma-ssi",
    "Mun-ssi", "Min-ssi", "Sa-ssi", "Seon-ssi", "Seong-ssi", "So-ssi", "Son-ssi", "Won-ssi",
    "Yu-ssi", "Yun-ssi", "Im-ssi", "Jeon-ssi", "Jeong-ssi", "Jo-ssi", "Ju-ssi", "Jin-ssi",
    "Cha-ssi", "Chae-ssi", "Tak-ssi", "Pyo-ssi", "Heo-ssi", "Hong-ssi", "Gam", "Gal",
    "Gang", "Gae", "Gaeng", "Gok", "Gong", "Gwak", "Gwan", "Gwok",
    "Gwon", "Geuk", "Geum", "Gi", "Gil", "Kim", "Kkot", "Na",
    "Nak", "Nam", "Nang", "Nae", "Naeng", "No", "Nok", "Nong",
    "Nu", "Nuk", "Nung", "Da", "Dak", "Dam", "Dang", "Dae",
    "Daeng", "Do", "Dok", "Dong", "Du", "Duk", "Dung", "Ra",
    "Rak", "Ram", "Rang", "Rae", "Raeng", "Ro", "Rok", "Rong",
    "Ru", "Ruk", "Rung", "Ma", "Mak", "Mam", "Mang", "Mae",
    "Maeng", "Mo", "Mok", "Mong", "Mu", "Muk", "Mung", "Ba",
    "Bak", "Bam", "Bang", "Bae", "Baeng", "Bo", "Bok", "Bong",
    "Bu", "Buk", "Bung", "Sa", "Sak", "Sam", "Sang", "Sae",
    "Saeng", "So", "Sok", "Song", "Su", "Suk", "Sung", "Ah",
    "Ak", "Am", "Ang", "Ae", "Aeng", "O", "Ok", "Ong",
    "U", "Uk", "Ung", "Ja", "Jak", "Jam", "Jang", "Jae",
    "Jaeng", "Jo", "Jok", "Jong", "Ju", "Juk", "Jung", "Cha",
    "Chak", "Cham", "Chang", "Chae", "Chaeng", "Cho", "Chok", "Chong",
    "Chu", "Chuk", "Chung", "Ka", "Kak", "Kam", "Kang", "Kae",
    "Kaeng", "Ko", "Kok", "Kong", "Ku", "Kuk", "Kung", "Ta",
    "Tak", "Tam", "Tang", "Tae", "Taeng", "To", "Tok", "Tong",
    "Tu", "Tuk", "Tung", "Pa", "Pak", "Pam", "Pang", "Pae",
    "Paeng", "Po", "Pok", "Pong", "Pu", "Puk", "Pung",
    
    // Final variations and completions - Chunk 5 (200 names)
    "Ha", "Hak", "Ham", "Hang", "Hae", "Haeng", "Ho", "Hok",
    "Hong", "Hu", "Huk", "Hung", "Ya", "Yak", "Yam", "Yang",
    "Yae", "Yaeng", "Yo", "Yok", "Yong", "Yu", "Yuk", "Yung",
    "Wa", "Wak", "Wam", "Wang", "Wae", "Waeng", "Wo", "Wok",
    "Wong", "Wu", "Wuk", "Wung", "Ga-ram", "Ga-eul", "Na-ri",
    "Da-eun", "Ra-hee", "Sa-rang", "Ba-da", "Cha-yeon", "Ma-ri", "Ta-hee",
    "La-ra", "Bit-na", "Han-bit", "Hae-rin", "Seul-gi", "Ye-rin", "Do-yeon",
    "Bo-gyeong", "Chae-rin", "Da-som", "Eun-chae", "Ga-young", "Ha-rin", "I-seul",
    "Joo-eun", "Ka-yeon", "Li-na", "Mo-a", "Na-eun", "O-reum", "Pa-ran",
    "Rae-won", "Sa-bine", "Tae-hee", "U-jin", "Woo-ri", "Ye-na", "Zu-ha",
    "Kim-gang", "Lee-gang", "Park-gang", "Choi-gang", "Jung-gang", "Kang-gang", "Cho-gang", "Yoon-gang",
    "Jang-gang", "Lim-gang", "Han-gang", "Oh-gang", "Seo-gang", "Shin-gang", "Kwon-gang", "Hwang-gang",
    "An-gang", "Song-gang", "Hong-gang", "Yang-gang", "Nam-gang", "No-gang", "Heo-gang", "Baek-gang",
    "Bae-gang", "Son-gang", "Moon-gang", "Ko-gang", "Yoo-gang", "Ha-gang", "Min-gang", "Sim-gang",
    "Won-gang", "Cha-gang", "Chae-gang", "Huh-gang", "Yuu-gang", "Bang-gang", "Tak-gang", "Sa-gang",
    "Yu-gang", "Gi-gang", "Gil-gang", "Myung-gang", "Mo-gang", "Mok-gang", "Maeng-gang", "Pyo-gang",
    "Pi-gang", "Pung-gang", "Pyeon-gang", "Pan-gang", "Paeng-gang", "Bong-gang", "Bok-gang", "Bu-gang",
    "Bin-gang", "Bing-gang", "Bi-gang", "Byeon-gang", "Beom-gang", "Beon-gang", "Bae-gang", "Baek-gang",
    "Ban-gang", "Bang-gang", "Boo-gang", "Bae-gang", "Go-gang", "Gok-gang", "Gong-gang", "Gwak-gang",
    "Gyo-gang", "Gu-gang", "Guk-gang", "Gung-gang", "Gwok-gang", "Gwon-gang", "Geun-gang", "Geum-gang",
    "Gi-gang", "Gil-gang", "Kim-gang", "Na-gang", "Nan-gang", "Nam-gang", "Namgung-gang", "Nang-gang",
    "Nae-gang", "No-gang", "Noe-gang", "Da-gang", "Dan-gang", "Dam-gang", "Dang-gang", "Dae-gang",
    "Do-gang", "Dok-gang", "Dokgo-gang", "Don-gang", "Dong-gang", "Dongbang-gang", "Du-gang", "Deung-gang",
    "Deungjeong-gang", "Ra-gang", "Ran-gang", "Rang-gang", "Ryeo-gang", "Ro-gang", "Roe-gang", "Ryu-gang",
    "Ri-gang", "Rim-gang", "Ma-gang", "Man-gang", "Mangjeol-gang", "Mae-gang", "Maeng-gang", "Myeong-gang",
    "Mo-gang", "Mok-gang", "Myo-gang", "Mu-gang", "Mubon-gang", "Muk-gang", "Mun-gang", "Mi-gang"
]